// extracted by mini-css-extract-plugin
module.exports = {"SupportObserver":"support-observer_SupportObserver__Zw5DY"};